<template>
  <div class="">
    <h2 v-text="i18n.login_title" class="text-center pb-6"></h2>
    <div class="flex flex-col xl:flex-row">
      <login
        :i18n="i18n.login"
        :login-route="i18n.url.login"
        :reset-route="i18n.url.reset"
        :signing-methods-route="i18n.url['signing-methods']"
        class="w-full xl:w-1/2"
        ref="login"
        @mode-register="switchTo('login')"
        @logged-in="$emit('logged-in')"
      ></login>
      <register
        :i18n="i18n.register"
        :registered="i18n.registered"
        :route="i18n.url.register"
        :applications="i18n.applications"
        class="w-full xl:w-1/2"
        @mode-register="switchTo('register')"
        @mode-preregister="switchTo('preregister')"
        @logged-in="$emit('logged-in')"
        ref="register"
      ></register>
    </div>
  </div>
</template>

<script>
import Login from "./Login";
import Register from "./Register";

export default {
  props: ["i18n"],
  components: { Login, Register },
  mixins: [],
  data: function () {
    return {
      form: {
        email: "",
        password: "",
      },
    };
  },
  methods: {
    switchTo(mode) {
      if (mode === "register") {
        this.$refs.login.mode = "register";
      }

      if (mode === "preregister") {
        this.$refs.login.mode = "login";
      }

      if (mode === "login") {
        this.$refs.register.mode = "preregister";
      }
    },
  },
  computed: {},
  mounted() {},
};
</script>
